<template>
	<v-dialog :persistent="true" max-width="480" v-model="show">
		<v-card>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 class="title mb-3 pl-3">
						{{$t('labels.recordPayment')}}
					</v-flex>
					<v-flex xs12>
						<DatePicker :dateLabel="$t('fields.date')" :error="paymentValidation.date" class="ml-2 mr-2"
									v-model="payment.date"></DatePicker>
					</v-flex>
					<v-flex xs12 pa-2>
						<CurrencyField
							:error="paymentValidation.amount"
							:label="$t('fields.amount') + ' (EUR)'"
							v-model="payment.amount"></CurrencyField>
					</v-flex>
				</v-layout>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn @click="closeModal">{{ $t('buttons.cancel') }}</v-btn>
				<v-btn @click="saveClick">{{ $t('buttons.ok') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import DatePicker from "../trinkets/DatePicker";
	import CurrencyField from "../trinkets/CurrencyField";

	export default {
		name: "Payment",
		props: ['show', 'id', 'invoice'],
		components: {
			DatePicker,
			CurrencyField
		},
		data: function () {
			return {
				payment: {
					id: null,
					date: null,
					amount: 0,
					invoice_id: null
				},
				paymentValidation: {
					date: '',
					amount: ''
				}
			}
		},
		watch: {
			show: function () {
				this.resetData();
				if (this.show) {
					this.payment.invoice_id = this.invoice;
					if (this.id != null) {
						let vm = this;
						this.$APICall('get', 'payments/' + this.id, {}, (data, success) => {
							if (success) {
								vm.payment = JSON.parse(JSON.stringify(data));
							} else {
								vm.$alert(vm.$t('alerts.basicError'));
							}
						});
					}
				}
			},
		},
		methods: {
			resetData() {
				let moment = require('moment');
				this.payment = {
					id: null,
					date: moment().format('YYYY-MM-DD'),
					amount: 0,
					invoice_id: null
				};
				this.validation = {
					date: '',
					amount: ''
				}
			},
			closeModal() {
				this.resetData();
				this.$emit('callback');
			},
			saveClick() {
				let success = true;

				if (this.payment.date == null) {
					success = false;
					this.paymentValidation.date = this.$t('alerts.fieldError');
				} else {
					this.paymentValidation.date = '';
				}

				if (this.payment.amount == 0) {
					success = false;
					this.paymentValidation.amount = this.$t('alerts.fieldError');
				} else {
					this.paymentValidation.amount = '';
				}

				if (success) {
					let vm = this;
					let action = 'post';
					let addition = '';
					if (vm.payment.id != null) {
						action = 'put';
						addition = '/' + vm.payment.id;
					}
					vm.$APICall(action, 'invoices-payments' + addition, vm.payment, (data, success) => {
						if (success) {
							vm.$notify(vm.$t('alerts.basicAdd'));
							vm.$emit('callback');
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			},
		},
		mounted() {
			let moment = require('moment');
			this.payment.date = moment().format('YYYY-MM-DD');
		}
	}
</script>

<style scoped>

</style>
